import React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Box, flameTheme, Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import StyledCountdownCalendar from 'pages/views/reports/CustomerData/BannerOffendingRecordsDetected/components/StyledCountdownCalendar';
import { numDaysBetween } from 'pages/views/reports/CustomerData/utils';
import { trackAnalyticsEvent } from 'root/apps/helpers/AnalyticsTracking';
import Modules from 'root/apps/shared_modules/Modules';

const BannerOffendingRecordsDetectedReports = () => {
  const [dateSensitiveInformationRemoved, setDateSensitiveInformationRemoved] = React.useState<
    string | null
  >(null);
  const [daysFromNow, setDaysFromNow] = React.useState<number | null>(null);

  const { colors } = flameTheme;

  const dateFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  } as Intl.DateTimeFormatOptions;

  React.useEffect(() => {
    const getOffendingRecordsCleanDate = async () => {
      const cleanOffendingRecordsConfigDate = await window.lsCloud.Config.access(
        'offending_records_clean_date'
      );

      // Create the target date and ensure it's treated as local time
      const targetDate = new Date(`${cleanOffendingRecordsConfigDate}T00:00:00`);

      setDateSensitiveInformationRemoved(
        Intl.DateTimeFormat(navigator.language, dateFormatOptions).format(targetDate)
      );

      const now = new Date();
      now.setHours(0, 0, 0, 0);

      setDaysFromNow(numDaysBetween(now, targetDate));
    };

    getOffendingRecordsCleanDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Flex padding="20px" alignItems="center" height="100%">
        <Flex flexDirection="column" flexWrap="wrap" width="70%" pr="1rem">
          <Box>
            <Text
              fontSize="21px"
              fontWeight="bold"
              mb={2}
              data-test="banner-title-offending-records-detected-reports"
              style={{
                margin: '0px 0px 0.75rem',
                lineHeight: '1.5',
                color: '#494c4c',
              }}
            >
              Action required: Store credit card details securely{' '}
              <span style={{ marginLeft: '4px' }} role="img" aria-label="Credit Card">
                &#128179;
              </span>
            </Text>
            <Text
              as="div"
              fontSize="14px"
              mb={3}
              color={colors.textDimmed}
              data-test="banner-message-offending-records-detected-reports"
            >
              <span>
                We&rsquo;ve noticed sensitive information, including card information, currently
                stored within your customer detail pages. Please be advised that by{' '}
                <strong>
                  <var style={{ whiteSpace: 'nowrap' }}>{dateSensitiveInformationRemoved}</var>
                </strong>
                , all numeric information from the table will be removed. If there is any
                non-sensitive information you need to retain, please report it. This ensures you
                will not lose it as part of this cleanup.
              </span>
            </Text>
            <Button
              onClick={() => {
                if (Modules.hasModule('data.pan_detection.tracker')) {
                  trackAnalyticsEvent({
                    eventCategory: 'PAN',
                    eventName: 'Report',
                    eventAction: 'ClickReportsPageBanner',
                    eventLabel: 'ViewReport',
                  });
                }
                window.PageRouter.goTo('/reports/customer-data');
              }}
              data-test="banner-button-enable-saved-payment-method-reports"
              variant="secondary"
              fill={true}
            >
              Customer data report
            </Button>
          </Box>
        </Flex>
        <Flex paddingRight="39px" width="30%" justifyContent="right">
          <StyledCountdownCalendar daysFromNow={daysFromNow} />
        </Flex>
      </Flex>
    </>
  );
};

export default BannerOffendingRecordsDetectedReports;
